import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Login from './pages/Login';
import ProjectSelection from './pages/ProjectSelection';
import ProjectView from './pages/ProjectView';
import ProjectGantt from './pages/ProjectGantt';
import AdminView from './pages/AdminView';
import ProjectFilesView from './pages/ProjectFilesView';
import ProjectFinances from './pages/ProjectFinances';
import RevenueDashboard from './pages/RevenueDashboard';  // ✅ IMPORTA AQUI

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />

        <Route element={<Layout />}>
          <Route path="/projects" element={<ProjectSelection />} />
          <Route path="/projects/:id" element={<ProjectView />} />
          <Route path="/projects/:id/gantt" element={<ProjectGantt />} />
          <Route path="/admin" element={<AdminView />} />
          
          {/* ✅ Novas rotas */}
          <Route path="/projects/:id/project-files" element={<ProjectFilesView />} />
          <Route path="/projects/:id/finance" element={<ProjectFinances />} />
          <Route path="/projects/:id/files" element={<ProjectFilesView />} />
          <Route path="/revenue-dashboard" element={<RevenueDashboard />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
